import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Filters } from 'libs/form';

const d = moment();
const initialFlt = {
  // status: 'active',
  datetime_from: d.startOf('day').format(),
  datetime_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change }) => {
  const { t } = useTranslation();

  const filters = [
    { type: 'doubledate', name: 'datetime', title: t('grid.Дата и время'), change },
    { type: 'input', name: 'vehicle_plate', title: t('sections.ГРЗ'), placeholder: t('form.А000AA 000 rus'), w: 150 },
    { type: 'input', name: 'mean_id', title: t('grid.СО'), placeholder: t('grid.СО'), w: 220 },
    { type: 'doublenumber', name: 'amount', title: t('grid.Сумма'), w: 80 },
    { type: 'zones', w: 160, name: 'zones', title: t('grid.Зона'), change },
    { type: 'input', name: 'comment', title: t('form.Причина'), w: 150 },
    { type: 'parking' },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'benefitFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
